/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { isEditionAuthorized, openIPListEditModal, toggleActiveness }
) => (
  isEditionAuthorized &&
  <>
    <OverlayTrigger
      overlay={<Tooltip id="open-IP-list-edit-tooltip">IP Listesi Düzenle</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openIPListEditModal(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")} />
        </span>
      </a>
    </OverlayTrigger>
    <OverlayTrigger
      overlay={<Tooltip id="toggle-activeness-tooltip">Aktif Pasif Yap</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-danger btn-sm"
        onClick={() => toggleActiveness(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
        </span>
      </a>
    </OverlayTrigger>
  </>
);